import styled from 'styled-components'

export const TableWrapper = styled.div `
    overflow-x: auto;
    margin-top: 2rem;
`